module.exports = __webpack_public_path__ + "static/media/upload.49a7b27f.svg";